var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserLove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 12.2222C12 10.9949 13.1193 10 14.5 10C15.7095 10 16.7684 10.7634 17 11.7778C17.2316 10.7634 18.2905 10 19.5 10C20.8807 10 22 10.9949 22 12.2222C22 15.0776 19.618 16.652 17.8744 17.5629C17.3276 17.8486 16.6724 17.8486 16.1256 17.5629C14.382 16.652 12 15.0776 12 12.2222Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7993 8.85724C13.5403 8.13122 14 7.1193 14 6C14 3.79086 12.2091 2 10 2C7.79086 2 6 3.79086 6 6C6 8.20914 7.79086 10 10 10C10.5598 10 11.0928 9.88498 11.5766 9.67729C11.9269 9.33362 12.3441 9.05624 12.7993 8.85724Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5066 12C10.5022 12.0732 10.5 12.1473 10.5 12.2222C10.5 16.0394 13.7006 17.9884 15.431 18.8924C15.6506 19.0071 15.8797 19.0961 16.1141 19.1595C14.6466 20.8967 12.4521 22 10 22C5.58172 22 2 18.4183 2 14C2 12.8954 2.89543 12 4 12H10.5066Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserLove);
export default __webpack_public_path__ + "static/media/user-love.0742dd92f7f274361550c202d3d4a9e7.svg";
export { ForwardRef as ReactComponent };